import {DocumentAmendment} from "common/flowmaster/types/amendment";
import {generateMultiLineDeleteAmendment} from "./delete";
import {generateDeleteClauseSubAmendments} from "./delete_clause";
import generateMultiParagraphAmendments from "./replace_insert";
import {generateSubclauseAmendments} from "./subclauses";

export function generateMultiLineAmendments(
  amendment: DocumentAmendment,
): DocumentAmendment {
  if (
    amendment.subclauses &&
    amendment.subclauses.length > 0 &&
    ["insert_before", "insert_after"].includes(amendment.action_type)
  ) {
    return generateSubclauseAmendments(amendment);
  }

  if (amendment.action_type === "delete") {
    return generateMultiLineDeleteAmendment(amendment);
  }

  if (amendment.action_type === "delete_clause") {
    return generateDeleteClauseSubAmendments(amendment);
  }

  if (
    ["replace", "insert_before", "insert_after"].includes(amendment.action_type)
  ) {
    return generateMultiParagraphAmendments(amendment);
  }

  return amendment;
}
